import styled from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

export const ReviewContainer = styled.div<{ noBorder?: boolean }>`
  border-bottom: ${({ noBorder }) => (noBorder ? 'none' : '2px solid #ebecf0')};
  padding: 0;

  @media (min-width: ${breakpoints.largeTablet}px) {
    border-bottom: ${({ noBorder }) =>
      noBorder ? 'none' : '2px solid #ebecf0'};
  }
`

export const ReviewTitle = styled.p`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 8px;
  margin-top: 0;
`

export const ReviewOrderNumberRow = styled.p`
  font-size: 14px;
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
  font-weight: 500;
`

export const ReviewText = styled.span`
  font-weight: 400;
  font-size: 14px;
  margin: 0;
`

export const ReviewErrorText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 14px;
  font-weight: 600;
`
